import MasterClocks from "@/components/Clocks/MasterClocks.vue";
import ClockIndex from "@/components/Clocks/Index.vue";
import ClockHeader from "@/components/Clocks/ClockHeader.vue";
import ClockSectionHeader from "@/components/Clocks/ClockSectionHeader.vue";
import ClockSectionActions from "@/components/Clocks/ClockSectionActions.vue";
import ClockActions from "@/components/Clocks/ClockActions.vue";
import ClockSourcePanel from "@/components/Clocks/ClockSourcePanel.vue";
import ClockListMenu from "@/components/Clocks/ClockMenuList.vue";
import ClockDetails from "@/components/Clocks/ClockDetails.vue";
import DetailsMaster from "@/components/Clocks/Details_Master.vue";
import DetailsConstraints from  "@/components/Clocks/ClockConstraints.vue";
import ClockMenu from "@/components/Clocks/SubMenu.vue";
import ClockStatistics from "@/components/Clocks/ClockStats.vue";
import DetailsBranding from "@/components/Clocks/DetailsBranding"

export default {
    path: '/:stationUid/clocks',
    components: {
        default: MasterClocks,
        menu: ClockListMenu
    },
    children: [
        {
            name: 'ClocksHome', path: "",
            components: {
                default: ClockIndex,
                subPageHeader: ClockSectionHeader,
                pageActions: ClockSectionActions
            }
        },
        {
            path: ':clockUid',
            components: {
                default:DetailsMaster,
                subPageHeader: ClockHeader,
                pageActions: ClockActions,
                rightPanel: ClockSourcePanel,
                pageSubMenu: ClockMenu,
            },
            children:[
                {
                    name: "ClockDetails", 
                    path: 'details',
                    components: {
                        default: ClockDetails,
                    }
                },
                {
                    name:'ClockConstraints',
                    path: 'constraints',
                    component: DetailsConstraints,
                },
                {
                    name:'ClockStats',
                    path: 'statistics',
                    component: ClockStatistics,
                },
                {
                    name:'ClockBranding',
                    path: 'branding',
                    component: DetailsBranding,
                }

            ],
        },
    ]
};